import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Button,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';
import { ContactForm } from '../../components/footer/ContactForm';
import { CTASection } from '../../components/footer/CTASection';

export const ReportPage: React.FC = () => {
  const theme = useTheme();

  const reportTypes = [
    {
      title: "Safety Concern",
      description: "Report any safety concerns or incidents",
      icon: "🚨",
    },
    {
      title: "Inappropriate Behavior",
      description: "Report inappropriate or unprofessional behavior",
      icon: "⚠️",
    },
    {
      title: "Platform Issue",
      description: "Report technical issues or platform problems",
      icon: "🔧",
    },
    {
      title: "Policy Violation",
      description: "Report violations of our terms of service or policies",
      icon: "📋",
    },
  ];

  const handleSubmit = async (data: any) => {
    // Handle report submission
    console.log('Report submitted:', data);
  };

  return (
    <PageLayout
      title="Report an Issue"
      subtitle="Help us maintain a safe and positive environment by reporting any concerns or issues."
      breadcrumbs={[
        { label: "Support", href: "/support" },
        { label: "Report an Issue" },
      ]}
    >
      {/* Report Types */}
      <ContentSection
        title="What Would You Like to Report?"
        subtitle="Choose the type of issue you'd like to report so we can help you most effectively."
        backgroundColor={theme.palette.grey[50]}
      >
        <Grid container spacing={4}>
          {reportTypes.map((type, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Box
                  sx={{
                    fontSize: '3rem',
                    mb: 2,
                  }}
                >
                  {type.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 1,
                    color: theme.palette.text.primary,
                  }}
                >
                  {type.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    lineHeight: 1.6,
                  }}
                >
                  {type.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </ContentSection>

      {/* Report Form */}
      <ContentSection
        title="Submit Your Report"
        subtitle="Please provide as much detail as possible to help us investigate and resolve the issue."
      >
        <ContactForm
          title="Report an Issue"
          subtitle="Fill out the form below to submit your report. We take all reports seriously and will investigate promptly."
          onSubmit={handleSubmit}
        />
      </ContentSection>

      {/* CTA Section */}
      <CTASection
        title="Need Immediate Help?"
        subtitle="For urgent safety concerns, please contact emergency services or our 24/7 safety hotline."
        primaryButton={{
          text: "Emergency Contact",
          href: "/emergency",
        }}
        secondaryButton={{
          text: "Safety Hotline",
          href: "tel:555-123-4567",
          variant: "outlined",
        }}
      />
    </PageLayout>
  );
};
